{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2024                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCReplaceDialog;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCCustomDialog, WEBLib.TMSFNCTypes,
  WEBLib.StdCtrls
  {$IFDEF WEBLIB}
  ,WEBLib.ExtCtrls
  {$ENDIF}
  {$IFDEF FMXLIB}
  ,FMX.Memo, FMX.ComboEdit
  {$ENDIF}
  ;

type
  TTMSFNCReplaceDialogOption = (rdoCurrentFile, rdoSelection, rdoAllOpenFiles, rdoCaseSensitive, rdoExpression,
    rdoWholeWordOnly, rdoWrapAtEndOfFile, rdoMoreEnabled,
    rdoFindEnabled, rdoFindNextEnabled, rdoReplaceAllEnabled, rdoReplaceEnabled,
    rdoCloseEnabled, rdoMoreExpanded, rdoDown);

  TTMSFNCReplaceDialogVisibleOption = (rdovCaseSensitive, rdovExpression,
    rdovWholeWordOnly, rdovWrapAtEndOfFile, rdovMore, rdovReplace, rdovReplaceAll, rdovFind, rdovFindNext,
    rdovClose, rdovFindCombo, rdovFindMemo, rdovReplaceCombo, rdovReplaceMemo, rdovReplaceAllRange, rdovCurrentFile, rdovSelection,
    rdovAllOpenFiles, rdovDirection);


  TTMSFNCReplaceDialogOptions = set of TTMSFNCReplaceDialogOption;
  TTMSFNCReplaceDialogVisibleOptions = set of TTMSFNCReplaceDialogVisibleOption;

const
  DefaultReplaceOptions = [rdoMoreEnabled, rdoReplaceAllEnabled, rdoFindEnabled, rdoFindNextEnabled, rdoReplaceEnabled, rdoCloseEnabled, rdoDown];
  DefaultVisibleReplaceOptions = [rdovCaseSensitive, rdovExpression,
    rdovWholeWordOnly, rdovWrapAtEndOfFile, rdovMore, rdovReplace, rdovReplaceAll, rdovFind, rdovFindNext,
    rdovClose, rdovFindCombo, rdovFindMemo, rdovReplaceCombo, rdovReplaceMemo, rdovReplaceAllRange, rdovCurrentFile, rdovSelection,
    rdovDirection];

type
  {$IFDEF FMXLIB}
  TTMSFNCReplaceDialogComboBox = class(TComboEdit);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCReplaceDialogComboBox = class(TComboBox);
  {$ENDIF}

  TTMSFNCReplaceDialogUILanguage = class(TPersistent)
  private
    FReplaceWith: string;
    FLess: string;
    FCaseSensitive: string;
    FSelection: string;
    FWrapAtEndOfFile: string;
    FDirection: string;
    FMore: string;
    FDown: string;
    FCaption: string;
    FWholeWordOnly: string;
    FExpression: string;
    FUp: string;
    FClose: string;
    FReplace: string;
    FFindWhat: string;
    FCurrentFile: string;
    FReplaceAllRange: string;
    FReplaceAll: string;
    FAllOpenFiles: string;
    FFind: string;
    FOnChanged: TNotifyEvent;
    FFindNext: string;
    function IsCaptionStored: Boolean;
    function IsCaseSensitiveStored: Boolean;
    function IsCloseStored: Boolean;
    function IsDirectionStored: Boolean;
    function IsDownStored: Boolean;
    function IsExpressionStored: Boolean;
    function IsReplaceStored: Boolean;
    function IsReplaceWithStored: Boolean;
    function IsLessStored: Boolean;
    function IsMoreStored: Boolean;
    function IsSelectionStored: Boolean;
    function IsUpStored: Boolean;
    function IsWholeWordOnlyStored: Boolean;
    function IsWrapAtEndOfFileStored: Boolean;
    function IsAllOpenFilesStored: Boolean;
    function IsCurrentFileStored: Boolean;
    function IsFindStored: Boolean;
    function IsFindWhatStored: Boolean;
    function IsReplaceAllRangeStored: Boolean;
    function IsReplaceAllStored: Boolean;
    procedure SetCaption(const Value: string);
    function IsFindNextStored: Boolean;
  protected
    procedure Changed;
  public
    constructor Create;
    procedure Assign(Source: TPersistent); override;
    property OnChanged: TNotifyEvent read FOnChanged write FOnChanged;
  published
    property AllOpenFiles: string read FAllOpenFiles write FAllOpenFiles stored IsAllOpenFilesStored;
    property Caption: string read FCaption write SetCaption stored IsCaptionStored;
    property CaseSensitive: string read FCaseSensitive write FCaseSensitive stored IsCaseSensitiveStored;
    property Close: string read FClose write FClose stored IsCloseStored;
    property CurrentFile: string read FCurrentFile write FCurrentFile stored IsCurrentFileStored;
    property Direction: string read FDirection write FDirection stored IsDirectionStored;
    property Down: string read FDown write FDown stored IsDownStored;
    property Expression: string read FExpression write FExpression stored IsExpressionStored;
    property Find: string read FFind write FFind stored IsFindStored;
    property FindNext: string read FFindNext write FFindNext stored IsFindNextStored;
    property FindWhat: string read FFindWhat write FFindWhat stored IsFindWhatStored;
    property Less: string read FLess write FLess stored IsLessStored;
    property More: string read FMore write FMore stored IsMoreStored;
    property Replace: string read FReplace write FReplace stored IsReplaceStored;
    property ReplaceAll: string read FReplaceAll write FReplaceAll stored IsReplaceAllStored;
    property ReplaceAllRange: string read FReplaceAllRange write FReplaceAllRange stored IsReplaceAllRangeStored;
    property ReplaceWith: string read FReplaceWith write FReplaceWith stored IsReplaceWithStored;
    property Selection: string read FSelection write FSelection stored IsSelectionStored;
    property Up: string read FUp write FUp stored IsUpStored;
    property WholeWordOnly: string read FWholeWordOnly write FWholeWordOnly stored IsWholeWordOnlyStored;
    property WrapAtEndOfFile: string read FWrapAtEndOfFile write FWrapAtEndOfFile stored IsWrapAtEndOfFileStored;
  end;

  ITMSFNCReplace = interface
    ['{02B8E1DA-978E-49B0-BC84-EF2ACCB47FCF}']
    procedure FindValue(AText: string);
    procedure FindNextValue(AText: string);
    procedure ReplaceValue(AFind, AReplace: string);
    procedure ReplaceAllValue(AFind, AReplace: string);
    procedure FindEditChange(APrevText, ANewText: string);
    procedure ReplaceEditChange(APrevText, ANewText: string);
  end;

  TTMSFNCReplaceDialogFindEvent = procedure(Sender: TObject; AFindText: string) of object;
  TTMSFNCReplaceDialogReplaceEvent = procedure(Sender: TObject; AFindText, AReplaceText: string) of object;
  TTMSFNCReplaceDialogReplaceEditChangeEvent = procedure(Sender: TObject; APrevText, ANewText: string) of object;

  TTMSFNCCustomReplaceDialog = class(TTMSFNCCustomDialog)
  private
    FDialogOpenedHeight, FDialogClosedHeight: Integer;
    FComboBoxFind: TTMSFNCReplaceDialogComboBox;
    FComboBoxReplace: TTMSFNCReplaceDialogComboBox;
    FButtonFind: TButton;
    FButtonFindNext: TButton;
    FButtonReplace: TButton;
    FButtonReplaceAll: TButton;
    FButtonClose: TButton;
    FButtonMore: TButton;
    FLabelFind: TLabel;
    FLabelFindMore: TLabel;
    FLabelReplace: TLabel;
    FLabelReplaceMore: TLabel;
    FMemoFind: TMemo;
    FMemoReplace: TMemo;
    FCheckBoxCase: TCheckBox;
    FCheckBoxWholeOnly: TCheckBox;
    FCheckBoxExpression: TCheckBox;
    FCheckBoxEOF: TCheckBox;
    FDirGroup: TGroupBox;
    FRadioDown: TRadioButton;
    FRadioUp: TRadioButton;
    FRangeGroup: TGroupBox;
    FRadioCurrentFile: TRadioButton;
    FRadioSelection: TRadioButton;
    FRadioAllOpen: TRadioButton;
    FOnReplace: TTMSFNCReplaceDialogReplaceEvent;
    FOnReplaceEditChange: TTMSFNCReplaceDialogReplaceEditChangeEvent;
    FOptions: TTMSFNCReplaceDialogOptions;
    FVisibleOptions: TTMSFNCReplaceDialogVisibleOptions;
    FMore: Boolean;
    FUILanguage: TTMSFNCReplaceDialogUILanguage;
    FAutoHistory: Boolean;
    FFindText: string;
    FFindList: TStringList;
    FReplaceText: string;
    FReplaceList: TStringList;
    FOnFind: TTMSFNCReplaceDialogFindEvent;
    FOnFindEditChange: TTMSFNCReplaceDialogReplaceEditChangeEvent;
    FOnReplaceAll: TTMSFNCReplaceDialogReplaceEvent;
    FOnFindNext: TTMSFNCReplaceDialogFindEvent;
    procedure SetUILanguage(const Value: TTMSFNCReplaceDialogUILanguage);
  protected
    function GetInstance: NativeUInt; override;
    procedure ButtonReplaceClick(Sender: TObject);
    procedure ButtonFindClick(Sender: TObject);
    procedure ButtonFindNextClick(Sender: TObject);
    procedure ButtonMoreClick(Sender: TObject);
    procedure ButtonReplaceAllClick(Sender: TObject);
    procedure ButtonCloseClick(Sender: TObject);
    procedure CheckBoxCaseClick(Sender: TObject);
    procedure CheckBoxWholeOnlyClick(Sender: TObject);
    procedure CheckBoxExpressionClick(Sender: TObject);
    procedure CheckBoxEOFClick(Sender: TObject);
    procedure RadioDirClick(Sender: TObject);
    procedure RadioRangeClick(Sender: TObject);
    procedure ComboBoxFindChange(Sender: TObject);
    {$IFDEF FMXLIB}
    procedure ComboBoxFindKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    procedure ComboBoxReplaceKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    procedure ComboBoxFindKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure ComboBoxReplaceKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    {$ENDIF}
    procedure ComboBoxReplaceChange(Sender: TObject);
    procedure MemoFindChange(Sender: TObject);
    procedure MemoReplaceChange(Sender: TObject);
    procedure UILanguageChanged(Sender: TObject);
    procedure UpdateMoreButton(const AValue: string);
    procedure EnableButtons;
    procedure DoFindText(AText: string);
    procedure DoFindNextText(AText: string);
    procedure DoFindEditChangeEvent(APrevText, ANewText: string);
    procedure DoReplaceText(AFindText, AReplaceText: string);
    procedure DoReplaceAllText(AFindText, AReplaceText: string);
    procedure DoReplaceEditChangeEvent(APrevText, ANewText: string);
    procedure DoFind(AText: string); virtual;
    procedure DoFindNext(AText: string); virtual;
    procedure DoReplace(AFindText, AReplaceText: string); virtual;
    procedure DoReplaceAll(AFindText, AReplaceText: string); virtual;
    procedure DoFindEditChange(APrevText, ANewText: string); virtual;
    procedure DoReplaceEditChange(APrevText, ANewText: string); virtual;
    procedure DoClose; override;
    procedure DoFormShow(Sender: TObject); override;
    procedure BuildDialog(AParent: TTMSFNCCustomDialogParent); override;
    property AutoHistory: Boolean read FAutoHistory write FAutoHistory default True;
    property FindText: string read FFindText write FFindText;
    property FindList: TStringList read FFindList write FFindList;
    property ReplaceText: string read FReplaceText write FReplaceText;
    property ReplaceList: TStringList read FReplaceList write FReplaceList;
    property UILanguage: TTMSFNCReplaceDialogUILanguage read FUILanguage write SetUILanguage;
    property Options: TTMSFNCReplaceDialogOptions read FOptions write FOptions default DefaultReplaceOptions;
    property VisibleOptions: TTMSFNCReplaceDialogVisibleOptions read FVisibleOptions write FVisibleOptions default DefaultVisibleReplaceOptions;
    property OnFind: TTMSFNCReplaceDialogFindEvent read FOnFind write FOnFind;
    property OnFindNext: TTMSFNCReplaceDialogFindEvent read FOnFindNext write FOnFindNext;
    property OnFindEditChange: TTMSFNCReplaceDialogReplaceEditChangeEvent read FOnFindEditChange write FOnFindEditChange;
    property OnReplace: TTMSFNCReplaceDialogReplaceEvent read FOnReplace write FOnReplace;
    property OnReplaceEditChange: TTMSFNCReplaceDialogReplaceEditChangeEvent read FOnReplaceEditChange write FOnReplaceEditChange;
    property OnReplaceAll: TTMSFNCReplaceDialogReplaceEvent read FOnReplaceAll write FOnReplaceAll;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWebDesktop)]
  {$ENDIF}
  TTMSFNCReplaceDialog = class(TTMSFNCCustomReplaceDialog)
  protected
    procedure RegisterRuntimeClasses; override;
  published
    property AutoHistory;
    property FindText;
    property FindList;
    property ReplaceText;
    property ReplaceList;
    property UILanguage;
    property Options;
    property VisibleOptions;
    property OnFind;
    property OnFindNext;
    property OnFindEditChange;
    property OnReplace;
    property OnReplaceEditChange;
    property OnReplaceAll;
    property OnClose;
  end;

implementation

uses
  SysUtils, Math;

{$R TMSFNCReplaceDialog.res}

{ TTMSFNCReplaceDialog }

procedure TTMSFNCReplaceDialog.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCReplaceDialog);
end;

{ TTMSFNCCustomReplaceDialog }

procedure TTMSFNCCustomReplaceDialog.BuildDialog(
  AParent: TTMSFNCCustomDialogParent);

  function InitCheckBox(AParentControl: TTMSFNCCustomDialogParent; ACaption: string; AChecked: Boolean; var ALeft: Integer; var ATop: Integer; var ACount: Integer): TCheckBox;
  begin
    Inc(ACount);

    Result := TCheckBox.Create(AParentControl);
    Result.Parent := AParentControl;
    Result.Width := 140;
    {$IFDEF FMXLIB}
    Result.IsChecked := AChecked;
    Result.Position.X := ALeft;
    Result.Position.Y := ATop;
    Result.Text := ACaption;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    Result.Checked := AChecked;
    Result.Left := ALeft;
    Result.Top := ATop;
    Result.Caption := ACaption;
    {$ENDIF}
    if ALeft <> 16 then
      ALeft := 16
    else
      ALeft := 160;

    if ACount mod 2 = 0 then
      ATop := ATop + Round(Result.Height) + 6;
  end;

  function InitButton(AParentControl: TTMSFNCCustomDialogParent; ACaption: string; ALeft: Integer; var ATop: Integer): TButton;
  begin
    Result := TButton.Create(AParentControl);
    Result.Parent := AParentControl;
    Result.Width := 80;
    {$IFNDEF VCLLIB}
    Result.Height := 22;
    {$ENDIF}
    {$IFDEF VCLLIB}
    Result.Height := 25;
    {$ENDIF}
    {$IFDEF FMXLIB}
    Result.Position.X := ALeft;
    Result.Position.Y := ATop;
    Result.Text := ACaption;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    Result.Left := ALeft;
    Result.Top := ATop;
    Result.Caption := ACaption;
    {$ENDIF}

    ATop := ATop + Round(Result.Height) + 3;
  end;

var
  tc, lc, cc, btm: Integer;
  tb: Integer;
  s: string;
begin
  inherited;
  tb := 13;
  tc := 16;
  lc := 16;
  cc := 0;

  if rdovFindCombo in VisibleOptions then
  begin
    FLabelFind := TLabel.Create(AParent);
    FLabelFind.Parent := AParent;
    FLabelFind.Enabled := not (rdoMoreExpanded in Options);
    {$IFDEF FMXLIB}
    FLabelFind.Text := UILanguage.FindWhat;
    FLabelFind.TextSettings.WordWrap := False;
    FLabelFind.AutoSize := True;
    FLabelFind.Position.X := 16;
    FLabelFind.Position.Y := tc;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FLabelFind.Left := 16;
    FLabelFind.Top := tc;
    FLabelFind.Caption := UILanguage.FindWhat;
    {$ENDIF}

    FComboBoxFind := TTMSFNCReplaceDialogComboBox.Create(AParent);
    FComboBoxFind.Parent := AParent;
    FComboBoxFind.Enabled := not (rdoMoreExpanded in Options);
    FComboBoxFind.TabOrder := 0;
    FComboBoxFind.Items.Assign(ReplaceList);
    FComboBoxFind.Text := FFindText;
    FComboBoxFind.Width := 240;
    FComboBoxFind.OnChange := @ComboBoxFindChange;
    {$IFDEF FMXLIB}
    FComboBoxFind.OnKeyDown := @ComboBoxFindKeyDown;
    FComboBoxFind.OnChangeTracking := ComboBoxFindChange;
    FComboBoxFind.Position.X := 95;
    FComboBoxFind.Position.Y := tc - 3;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FComboBoxFind.OnKeyDown := @ComboBoxFindKeyDown;
    FComboBoxFind.Left := 95;
    FComboBoxFind.Top := tc - 3;
    {$ENDIF}
    {$IFDEF WEBLIB}
    FComboBoxFind.Style := csDropDown;
    {$ENDIF}

    tc := tc + Round(FComboBoxFind.Height){$IFNDEF VCLLIB} + 7{$ENDIF};
  end;

  if rdovReplaceCombo in VisibleOptions then
  begin
    FLabelReplace := TLabel.Create(AParent);
    FLabelReplace.Parent := AParent;
    FLabelReplace.Enabled := not (rdoMoreExpanded in Options);
    {$IFDEF FMXLIB}
    FLabelReplace.Text := UILanguage.ReplaceWith;
    FLabelReplace.TextSettings.WordWrap := False;
    FLabelReplace.AutoSize := True;
    FLabelReplace.Position.X := 16;
    FLabelReplace.Position.Y := tc;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FLabelReplace.Left := 16;
    FLabelReplace.Top := tc;
    FLabelReplace.Caption := UILanguage.ReplaceWith;
    {$ENDIF}

    FComboBoxReplace := TTMSFNCReplaceDialogComboBox.Create(AParent);
    FComboBoxReplace.Parent := AParent;
    FComboBoxReplace.Enabled := not (rdoMoreExpanded in Options);
    FComboBoxReplace.TabOrder := 1;
    FComboBoxReplace.Items.Assign(ReplaceList);
    FComboBoxReplace.Text := FReplaceText;
    FComboBoxReplace.Width := 240;
    FComboBoxReplace.OnChange := @ComboBoxReplaceChange;
    {$IFDEF FMXLIB}
    FComboBoxReplace.OnKeyDown := @ComboBoxReplaceKeyDown;
    FComboBoxReplace.OnChangeTracking := ComboBoxReplaceChange;
    FComboBoxReplace.Position.X := 95;
    FComboBoxReplace.Position.Y := tc - 3;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FComboBoxReplace.OnKeyDown := @ComboBoxReplaceKeyDown;
    FComboBoxReplace.Left := 95;
    FComboBoxReplace.Top := tc - 3;
    {$ENDIF}
    {$IFDEF WEBLIB}
    FComboBoxReplace.Style := csDropDown;
    {$ENDIF}

    tc := tc + Round(FComboBoxReplace.Height) + 7;
  end;

  if rdovCaseSensitive in VisibleOptions then
  begin
    FCheckBoxCase := InitCheckBox(AParent, UILanguage.CaseSensitive, rdoCaseSensitive in Options, lc, tc, cc);
    {$IFDEF FMXLIB}
    FCheckBoxCase.OnChange := @CheckBoxCaseClick;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FCheckBoxCase.OnClick := CheckBoxCaseClick;
    {$ENDIF}
    FCheckBoxCase.TabOrder := 2;
  end;

  if rdovWholeWordOnly in VisibleOptions then
  begin
    FCheckBoxWholeOnly := InitCheckBox(AParent, UILanguage.WholeWordOnly, rdoWholeWordOnly in Options, lc, tc, cc);
    {$IFDEF FMXLIB}
    FCheckBoxWholeOnly.OnChange := @CheckBoxWholeOnlyClick;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FCheckBoxWholeOnly.OnClick := CheckBoxWholeOnlyClick;
    {$ENDIF}
    FCheckBoxWholeOnly.TabOrder := 3;
  end;

  if rdovExpression in VisibleOptions then
  begin
    FCheckBoxExpression := InitCheckBox(AParent, UILanguage.Expression, rdoExpression in Options, lc, tc, cc);
    {$IFDEF FMXLIB}
    FCheckBoxExpression.OnChange := @CheckBoxExpressionClick;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FCheckBoxExpression.OnClick := CheckBoxExpressionClick;
    {$ENDIF}
    FCheckBoxExpression.TabOrder := 4;
  end;

  if rdovWrapAtEndOfFile in VisibleOptions then
  begin
    FCheckBoxEOF := InitCheckBox(AParent, UILanguage.WrapAtEndOfFile, rdoWrapAtEndOfFile in Options, lc, tc, cc);
    {$IFDEF FMXLIB}
    FCheckBoxEOF.OnChange := @CheckBoxEOFClick;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FCheckBoxEOF.OnClick := CheckBoxEOFClick;
    {$ENDIF}
    FCheckBoxEOF.TabOrder := 5;
  end;

  if rdovFind in VisibleOptions then
  begin
    FButtonFind := InitButton(AParent, UILanguage.Find, 345, tb);
    FButtonFind.OnClick := ButtonFindClick;
    FButtonFind.TabOrder := 6;
  end;

  if rdovFindNext in VisibleOptions then
  begin
    FButtonFindNext := InitButton(AParent, UILanguage.FindNext, 345, tb);
    FButtonFindNext.OnClick := ButtonFindNextClick;
    FButtonFindNext.TabOrder := 7;
  end;

  if rdovReplace in VisibleOptions then
  begin
    FButtonReplace := InitButton(AParent, UILanguage.Replace, 345, tb);
    FButtonReplace.OnClick := ButtonReplaceClick;
    FButtonReplace.TabOrder := 8;
  end;

  if rdovReplaceAll in VisibleOptions then
  begin
    FButtonReplaceAll := InitButton(AParent, UILanguage.ReplaceAll, 345, tb);
    FButtonReplaceAll.OnClick := ButtonReplaceAllClick;
    FButtonReplaceAll.TabOrder := 9;
  end;

  if rdovClose in VisibleOptions then
  begin
    FButtonClose := InitButton(AParent, UILanguage.Close, 345, tb);
    FButtonClose.OnClick := ButtonCloseClick;
    FButtonClose.TabOrder := 10;
  end;

  if cc mod 2 = 1 then
    tc := tc + 26;

  btm := tc;

  if rdovDirection in VisibleOptions then
  begin
    FDirGroup := TGroupBox.Create(AParent);
    FDirGroup.Parent := AParent;
    FDirGroup.Width := 140;
    FDirGroup.Height := 45;
    {$IFDEF FMXLIB}
    FDirGroup.Text := UILanguage.Direction;
    FDirGroup.Position.X := 16;
    FDirGroup.Position.Y := tc;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FDirGroup.Caption := UILanguage.Direction;
    FDirGroup.Left := 16;
    FDirGroup.Top := tc;
    {$ENDIF}

    FRadioUp := TRadioButton.Create(FDirGroup);
    FRadioUp.Parent := FDirGroup;
    {$IFNDEF VCLLIB}
    FRadioUp.GroupName := 'direction';
    {$ENDIF}
    FRadioUp.TabOrder := 13;
    {$IFDEF FMXLIB}
    FRadioUp.OnChange := @RadioDirClick;
    FRadioUp.Text := UILanguage.Up;
    FRadioUp.Position.X := 8;
    FRadioUp.Position.Y := 18;
    if not (rdoDown in Options) then
      FRadioUp.IsChecked := True;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FRadioUp.OnClick := RadioDirClick;
    FRadioUp.Caption := UILanguage.Up;
    FRadioUp.Left := 8;
    {$IFNDEF WEBLIB}
    FRadioUp.Top := 18;
    {$ENDIF}
    {$IFDEF WEBLIB}
    FRadioUp.Top := 14;
    {$ENDIF}
    if not (rdoDown in Options) then
      FRadioUp.Checked := True;
    {$ENDIF}

    FRadioDown := TRadioButton.Create(FDirGroup);
    FRadioDown.Parent := FDirGroup;
    {$IFNDEF VCLLIB}
    FRadioDown.GroupName := 'direction';
    {$ENDIF}
    FRadioDown.TabOrder := 14;
    {$IFDEF FMXLIB}
    FRadioDown.OnChange := @RadioDirClick;
    FRadioDown.Text := UILanguage.Down;
    FRadioDown.Position.X := 65;
    FRadioDown.Position.Y := 18;
    if (rdoDown in Options) then
      FRadioDown.IsChecked := True;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FRadioDown.OnClick := RadioDirClick;
    FRadioDown.Caption := UILanguage.Down;
    FRadioDown.Left := 65;
    {$IFNDEF WEBLIB}
    FRadioDown.Top := 18;
    {$ENDIF}
    {$IFDEF WEBLIB}
    FRadioDown.Top := 14;
    {$ENDIF}
    if (rdoDown in Options) then
      FRadioDown.Checked := True;
    {$ENDIF}

    tc := tc + Round(FDirGroup.Height);
    btm := btm + Round(FDirGroup.Height);
  end;

  if rdovReplaceAllRange in VisibleOptions then
  begin
    if rdovDirection in VisibleOptions then
    begin
      tc := tc + 10;
      btm := btm + 10;
    end;

    FRangeGroup := TGroupBox.Create(AParent);
    FRangeGroup.Parent := AParent;
    FRangeGroup.Height := 45;
    {$IFDEF FMXLIB}
    FRangeGroup.Text := UILanguage.ReplaceAllRange;
    FRangeGroup.Position.X := 16;
    FRangeGroup.Position.Y := tc;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FRangeGroup.Caption := UILanguage.ReplaceAllRange;
    FRangeGroup.Left := 16;
    FRangeGroup.Top := tc;
    {$ENDIF}

    tc := tc + Round(FRangeGroup.Height);
    btm := btm + Round(FDirGroup.Height);

    lc := 8;

    if rdovCurrentFile in VisibleOptions then
    begin
      FRadioCurrentFile := TRadioButton.Create(FRangeGroup);
      FRadioCurrentFile.Parent := FRangeGroup;
      FRadioCurrentFile.TabOrder := 15;
      {$IFNDEF VCLLIB}
      FRadioCurrentFile.GroupName := 'range';
      {$ENDIF}
      {$IFDEF FMXLIB}
      FRadioCurrentFile.OnChange := @RadioRangeClick;
      FRadioCurrentFile.Text := UILanguage.CurrentFile;
      FRadioCurrentFile.Position.X := lc;
      FRadioCurrentFile.Position.Y := 18;
      if (rdoCurrentFile in Options) then
        FRadioCurrentFile.IsChecked := True;
      {$ENDIF}
      {$IFDEF CMNWEBLIB}
      FRadioCurrentFile.OnClick := RadioRangeClick;
      FRadioCurrentFile.Caption := UILanguage.CurrentFile;
      FRadioCurrentFile.Left := lc;
      {$IFNDEF WEBLIB}
      FRadioCurrentFile.Top := 18;
      {$ENDIF}
      {$IFDEF WEBLIB}
      FRadioCurrentFile.Top := 14;
      {$ENDIF}
      if not (rdoDown in Options) then
        FRadioCurrentFile.Checked := True;
      {$ENDIF}

      lc := lc + 90;
    end;

    if rdovSelection in VisibleOptions then
    begin
      FRadioSelection := TRadioButton.Create(FRangeGroup);
      FRadioSelection.Parent := FRangeGroup;
      FRadioSelection.TabOrder := 16;
      {$IFNDEF VCLLIB}
      FRadioSelection.GroupName := 'range';
      {$ENDIF}
      {$IFDEF FMXLIB}
      FRadioSelection.OnChange := @RadioRangeClick;
      FRadioSelection.Text := UILanguage.Selection;
      FRadioSelection.Position.X := lc;
      FRadioSelection.Position.Y := 18;
      if (rdoSelection in Options) then
        FRadioSelection.IsChecked := True;
      {$ENDIF}
      {$IFDEF CMNWEBLIB}
      FRadioSelection.OnClick := RadioRangeClick;
      FRadioSelection.Caption := UILanguage.Selection;
      FRadioSelection.Left := lc;
      {$IFNDEF WEBLIB}
      FRadioSelection.Top := 18;
      {$ENDIF}
      {$IFDEF WEBLIB}
      FRadioSelection.Top := 14;
      {$ENDIF}
      if not (rdoDown in Options) then
        FRadioSelection.Checked := True;
      {$ENDIF}

      lc := lc + 90;
    end;

    if rdovAllOpenFiles in VisibleOptions then
    begin
      FRadioAllOpen := TRadioButton.Create(FRangeGroup);
      FRadioAllOpen.Parent := FRangeGroup;
      FRadioAllOpen.TabOrder := 17;
      {$IFNDEF VCLLIB}
      FRadioAllOpen.GroupName := 'range';
      {$ENDIF}
      {$IFDEF FMXLIB}
      FRadioAllOpen.OnChange := @RadioRangeClick;
      FRadioAllOpen.Text := UILanguage.AllOpenFiles;
      FRadioAllOpen.Position.X := lc;
      FRadioAllOpen.Position.Y := 18;
      if (rdoAllOpenFiles in Options) then
        FRadioAllOpen.IsChecked := True;
      {$ENDIF}
      {$IFDEF CMNWEBLIB}
      FRadioAllOpen.OnClick := RadioRangeClick;
      FRadioAllOpen.Caption := UILanguage.AllOpenFiles;
      FRadioAllOpen.Left := lc;
      {$IFNDEF WEBLIB}
      FRadioAllOpen.Top := 18;
      {$ENDIF}
      {$IFDEF WEBLIB}
      FRadioAllOpen.Top := 14;
      {$ENDIF}
      if not (rdoDown in Options) then
        FRadioAllOpen.Checked := True;
      {$ENDIF}

      lc := lc + 100;
    end;

    FRangeGroup.Width := lc;
  end;

  tb := Max(tc - 25, tb);

  if rdovMore in VisibleOptions then
  begin
    if rdoMoreExpanded in Options then
      s := UILanguage.Less
    else
      s := UILanguage.More;

    FButtonMore := InitButton(AParent, s, 345, tb);
    FButtonMore.OnClick := ButtonMoreClick;
    FButtonMore.TabOrder := 18;
    btm := Max(btm, tb - 3);
  end;

  btm := btm + 10;
  FDialogClosedHeight := btm;
  FDialogOpenedHeight := btm;

  if rdovMore in VisibleOptions then
  begin
    cc := btm;
    if rdovFindMemo in VisibleOptions then
    begin
      FLabelFindMore := TLabel.Create(AParent);
      FLabelFindMore.Parent := AParent;
      FLabelFindMore.Visible := rdoMoreExpanded in Options;
      {$IFDEF FMXLIB}
      FLabelFindMore.Text := UILanguage.FindWhat;
      FLabelFindMore.TextSettings.WordWrap := False;
      FLabelFindMore.AutoSize := True;
      FLabelFindMore.Position.X := 16;
      FLabelFindMore.Position.Y := cc;
      {$ENDIF}
      {$IFDEF CMNWEBLIB}
      FLabelFindMore.Left := 16;
      FLabelFindMore.Top := cc;
      FLabelFindMore.Caption := UILanguage.FindWhat;
      {$ENDIF}

      FMemoFind := TMemo.Create(AParent);
      FMemoFind.Parent := AParent;
      FMemoFind.Visible := rdoMoreExpanded in Options;
      FMemoFind.TabOrder := 19;
      FMemoFind.Width := 410;
      FMemoFind.Height := 80;
      FMemoFind.OnChange := @MemoFindChange;
      {$IFDEF FMXLIB}
      FMemoFind.OnChangeTracking := MemoFindChange;
      FMemoFind.Position.X := 16;
      FMemoFind.Position.Y := FLabelFindMore.Position.Y + FLabelFindMore.Height + 7;
      cc :=  Round(FMemoFind.Position.Y + FMemoFind.Height) + 8;
      {$ENDIF}
      {$IFDEF CMNWEBLIB}
      FMemoFind.Left := 16;
      FMemoFind.Top := FLabelFindMore.Top + FLabelFindMore.Height{$IFNDEF VCLLIB} + 7{$ENDIF};
      cc := FMemoFind.Top + FMemoFind.Height + 8;
      {$ENDIF}
    end;

    if rdovReplaceMemo in VisibleOptions then
    begin
      FLabelReplaceMore := TLabel.Create(AParent);
      FLabelReplaceMore.Parent := AParent;
      FLabelReplaceMore.Visible := rdoMoreExpanded in Options;
      {$IFDEF FMXLIB}
      FLabelReplaceMore.Text := UILanguage.ReplaceWith;
      FLabelReplaceMore.TextSettings.WordWrap := False;
      FLabelReplaceMore.AutoSize := True;
      FLabelReplaceMore.Position.X := 16;
      FLabelReplaceMore.Position.Y := cc;
      {$ENDIF}
      {$IFDEF CMNWEBLIB}
      FLabelReplaceMore.Left := 16;
      FLabelReplaceMore.Top := cc;
      FLabelReplaceMore.Caption := UILanguage.ReplaceWith;
      {$ENDIF}

      FMemoReplace := TMemo.Create(AParent);
      FMemoReplace.Parent := AParent;
      FMemoReplace.Visible := rdoMoreExpanded in Options;
      FMemoReplace.TabOrder := 20;
      FMemoReplace.Width := 410;
      FMemoReplace.Height := 80;
      FMemoReplace.OnChange := @MemoReplaceChange;
      {$IFDEF FMXLIB}
      FMemoReplace.OnChangeTracking := MemoReplaceChange;
      FMemoReplace.Position.X := 16;
      FMemoReplace.Position.Y := FLabelReplaceMore.Position.Y + FLabelReplaceMore.Height + 7;
      cc :=  Round(FMemoReplace.Position.Y + FMemoReplace.Height) + 8;
      {$ENDIF}
      {$IFDEF CMNWEBLIB}
      FMemoReplace.Left := 16;
      FMemoReplace.Top := FLabelReplaceMore.Top + FLabelReplaceMore.Height{$IFNDEF VCLLIB} + 7{$ENDIF};
      cc :=  Round(FMemoReplace.Top + FMemoReplace.Height) + 8;
      {$ENDIF}
    end;

    if cc <> btm then
      FDialogOpenedHeight := cc + 5;
  end;

  if rdoMoreExpanded in Options then
  begin
    FMore := True;
    DialogHeight := FDialogOpenedHeight;
  end
  else
  begin
    DialogHeight := FDialogClosedHeight;
  end;

  Caption := UILanguage.Caption;
  EnableButtons;
end;

procedure TTMSFNCCustomReplaceDialog.ButtonCloseClick(Sender: TObject);
begin
  if Assigned(Form) then
    Form.Close;
end;

procedure TTMSFNCCustomReplaceDialog.ButtonFindClick(Sender: TObject);
begin
  DoFindText(FFindText);
end;

procedure TTMSFNCCustomReplaceDialog.ButtonFindNextClick(Sender: TObject);
begin
  DoFindNextText(FFindText);
end;

procedure TTMSFNCCustomReplaceDialog.ButtonReplaceAllClick(Sender: TObject);
begin
  DoReplaceAllText(FFindText, FReplaceText);
end;

procedure TTMSFNCCustomReplaceDialog.ButtonReplaceClick(Sender: TObject);
begin
  DoReplaceText(FFindText, FReplaceText);
end;

procedure TTMSFNCCustomReplaceDialog.ButtonMoreClick(Sender: TObject);
begin
  if not FMore then
  begin
    UpdateMoreButton(UILanguage.Less);
    Options := Options + [rdoMoreExpanded];
    DialogHeight := FDialogOpenedHeight;
  end
  else
  begin
    UpdateMoreButton(UILanguage.More);
    Options := Options - [rdoMoreExpanded];
    DialogHeight := FDialogClosedHeight;
  end;

  if rdovFindMemo in VisibleOptions then
  begin
    FLabelFindMore.Visible := not FMore;
    FMemoFind.Visible := not FMore;
  end;

  if rdovReplaceMemo in VisibleOptions then
  begin
    FLabelReplaceMore.Visible := not FMore;
    FMemoReplace.Visible := not FMore;
  end;

  if rdovFindCombo in VisibleOptions then
  begin
    FLabelFind.Enabled := FMore;
    FComboBoxFind.Enabled := FMore;
  end;

  if rdovReplaceCombo in VisibleOptions then
  begin
    FLabelReplace.Enabled := FMore;
    FComboBoxReplace.Enabled := FMore;
  end;
  FMore := not FMore;
end;

procedure TTMSFNCCustomReplaceDialog.CheckBoxCaseClick(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  if FCheckBoxCase.IsChecked then
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  if FCheckBoxCase.Checked then
  {$ENDIF}
    Options := Options + [rdoCaseSensitive]
  else
    Options := Options - [rdoCaseSensitive];
end;

procedure TTMSFNCCustomReplaceDialog.CheckBoxEOFClick(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  if FCheckBoxEOF.IsChecked then
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  if FCheckBoxEOF.Checked then
  {$ENDIF}
    Options := Options + [rdoWrapAtEndOfFile]
  else
    Options := Options - [rdoWrapAtEndOfFile];
end;

procedure TTMSFNCCustomReplaceDialog.CheckBoxExpressionClick(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  if FCheckBoxExpression.IsChecked then
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  if FCheckBoxExpression.Checked then
  {$ENDIF}
    Options := Options + [rdoExpression]
  else
    Options := Options - [rdoExpression];
end;

procedure TTMSFNCCustomReplaceDialog.CheckBoxWholeOnlyClick(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  if FCheckBoxWholeOnly.IsChecked then
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  if FCheckBoxWholeOnly.Checked then
  {$ENDIF}
    Options := Options + [rdoWholeWordOnly]
  else
    Options := Options - [rdoWholeWordOnly];
end;

procedure TTMSFNCCustomReplaceDialog.ComboBoxFindChange(Sender: TObject);
var
  s: string;
begin
  s := FComboBoxFind.Text;
  DoFindEditChangeEvent(FindText, s);
  FindText := s;
  EnableButtons;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomReplaceDialog.ComboBoxFindKeyDown(Sender: TObject;
  var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCCustomReplaceDialog.ComboBoxFindKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
{$ENDIF}
begin
  if Key = KEY_RETURN then
    DoFindText(FFindText);
end;

procedure TTMSFNCCustomReplaceDialog.ComboBoxReplaceChange(Sender: TObject);
var
  s: string;
begin
  s := FComboBoxReplace.Text;
  DoReplaceEditChangeEvent(ReplaceText, s);
  ReplaceText := s;
  EnableButtons;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomReplaceDialog.ComboBoxReplaceKeyDown(Sender: TObject;
  var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCCustomReplaceDialog.ComboBoxReplaceKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
{$ENDIF}
begin
  if Key = KEY_RETURN then
    DoReplaceText(FFindText, FReplaceText);
end;

constructor TTMSFNCCustomReplaceDialog.Create(AOwner: TComponent);
begin
  inherited;
  FDialogOpenedHeight := 0;
  FDialogClosedHeight := 0;
  FOptions := DefaultReplaceOptions;
  FVisibleOptions := DefaultVisibleReplaceOptions;
  FMore := False;
  FAutoHistory := True;
  FReplaceText := '';

  FUILanguage := TTMSFNCReplaceDialogUILanguage.Create;
  FUILanguage.OnChanged := @UILanguageChanged;
  FReplaceList := TStringList.Create;
  FFindList := TStringList.Create;

  {$IFDEF WEBLIB}
  Caption := UILanguage.Caption;
  {$ENDIF}
  AllowReturnKeyClose := False;
end;

destructor TTMSFNCCustomReplaceDialog.Destroy;
begin
  FReplaceList.Free;
  FFindList.Free;
  FUILanguage.Free;
  inherited;
end;

procedure TTMSFNCCustomReplaceDialog.DoClose;
begin
  if FAutoHistory then
  begin
    if (FFindText <> '') and (FFindList.IndexOf(FFindText) = -1) then
      FFindList.Add(FindText);

    if (FReplaceText <> '') and (FReplaceList.IndexOf(FReplaceText) = -1) then
      FReplaceList.Add(FReplaceText);
  end;

  inherited;
end;

procedure TTMSFNCCustomReplaceDialog.DoFindText(AText: string);
var
  f: ITMSFNCReplace;
begin
  if FAutoHistory then
  begin
    if (FFindText <> '') and (FFindList.IndexOf(FFindText) = -1) then
      FFindList.Add(FindText);

    if rdovFindCombo in VisibleOptions then
    begin
      FComboBoxFind.Items.Assign(FFindList);
      FComboBoxFind.Text := AText;
    end;
  end;

  if Supports(Control, ITMSFNCReplace, f) then
    f.FindValue(AText);

  DoFind(AText);
end;

procedure TTMSFNCCustomReplaceDialog.DoFormShow(Sender: TObject);
begin
  inherited;
  if Assigned(FComboBoxFind) and FComboBoxFind.Visible then
    FComboBoxFind.SetFocus
  else if Assigned(FComboBoxReplace) and FComboBoxReplace.Visible then
    FComboBoxReplace.SetFocus;

  if Assigned(FMemoFind) and FMemoFind.Visible then
    FMemoFind.SetFocus
  else if Assigned(FMemoReplace) and FMemoReplace.Visible then
    FMemoReplace.SetFocus;
end;

procedure TTMSFNCCustomReplaceDialog.DoFind(AText: string);
begin
  if Assigned(OnFind) then
    OnFind(Self, AText);
end;

procedure TTMSFNCCustomReplaceDialog.DoFindEditChange(APrevText,
  ANewText: string);
begin
  if Assigned(OnFindEditChange) then
    OnFindEditChange(Self, APrevText, ANewText);
end;

procedure TTMSFNCCustomReplaceDialog.DoFindEditChangeEvent(APrevText,
  ANewText: string);
var
  f: ITMSFNCReplace;
begin
  if Supports(Control, ITMSFNCReplace, f) then
    f.FindEditChange(APrevText, ANewText);

  DoFindEditChange(APrevText, ANewText);
end;

procedure TTMSFNCCustomReplaceDialog.DoFindNext(AText: string);
begin
  if Assigned(OnFindNext) then
    OnFindNext(Self, AText);
end;

procedure TTMSFNCCustomReplaceDialog.DoFindNextText(AText: string);
var
  f: ITMSFNCReplace;
begin
  if FAutoHistory then
  begin
    if (FFindText <> '') and (FFindList.IndexOf(FFindText) = -1) then
      FFindList.Add(FindText);

    if rdovFindCombo in VisibleOptions then
    begin
      FComboBoxFind.Items.Assign(FFindList);
      FComboBoxFind.Text := AText;
    end;
  end;

  if Supports(Control, ITMSFNCReplace, f) then
    f.FindNextValue(AText);

  DoFindNext(AText);
end;

procedure TTMSFNCCustomReplaceDialog.DoReplaceText(AFindText, AReplaceText: string);
var
  f: ITMSFNCReplace;
begin
  if FAutoHistory then
  begin
    if (FFindText <> '') and (FFindList.IndexOf(FFindText) = -1) then
      FFindList.Add(FindText);

    if rdovFindCombo in VisibleOptions then
    begin
      FComboBoxFind.Items.Assign(FFindList);
      FComboBoxFind.Text := AFindText;
    end;

    if (FReplaceText <> '') and (FReplaceList.IndexOf(FReplaceText) = -1) then
      FReplaceList.Add(FReplaceText);

    if rdovReplaceCombo in VisibleOptions then
    begin
      FComboBoxReplace.Items.Assign(FReplaceList);
      FComboBoxReplace.Text := AReplaceText;
    end;
  end;

  if Supports(Control, ITMSFNCReplace, f) then
    f.ReplaceValue(AFindText, AReplaceText);

  DoReplace(AFindText, AReplaceText);
end;

procedure TTMSFNCCustomReplaceDialog.DoReplace(AFindText, AReplaceText: string);
begin
  if Assigned(OnReplace) then
    OnReplace(Self, AFindText, AReplaceText);
end;

procedure TTMSFNCCustomReplaceDialog.DoReplaceAll(AFindText,
  AReplaceText: string);
begin
  if Assigned(OnReplaceAll) then
    OnReplaceAll(Self, AFindText, AReplaceText);
end;

procedure TTMSFNCCustomReplaceDialog.DoReplaceAllText(AFindText, AReplaceText: string);
var
  f: ITMSFNCReplace;
begin
  if FAutoHistory then
  begin
    if (FFindText <> '') and (FFindList.IndexOf(FFindText) = -1) then
      FFindList.Add(FindText);

    if rdovFindCombo in VisibleOptions then
    begin
      FComboBoxFind.Items.Assign(FFindList);
      FComboBoxFind.Text := AFindText;
    end;

    if (FReplaceText <> '') and (FReplaceList.IndexOf(FReplaceText) = -1) then
      FReplaceList.Add(FReplaceText);

    if rdovReplaceCombo in VisibleOptions then
    begin
      FComboBoxReplace.Items.Assign(FReplaceList);
      FComboBoxReplace.Text := AReplaceText;
    end;
  end;

  if Supports(Control, ITMSFNCReplace, f) then
    f.ReplaceAllValue(AFindText, AReplaceText);

  DoReplaceAll(AFindText, AReplaceText);
end;

procedure TTMSFNCCustomReplaceDialog.DoReplaceEditChange(APrevText,
  ANewText: string);
begin
  if Assigned(OnReplaceEditChange) then
    OnReplaceEditChange(Self, APrevText, ANewText);
end;

procedure TTMSFNCCustomReplaceDialog.DoReplaceEditChangeEvent(APrevText,
  ANewText: string);
var
  f: ITMSFNCReplace;
begin
  if Supports(Control, ITMSFNCReplace, f) then
    f.ReplaceEditChange(APrevText, ANewText);

  DoReplaceEditChange(APrevText, ANewText);
end;

procedure TTMSFNCCustomReplaceDialog.EnableButtons;
begin
  if rdovFind in VisibleOptions then
    FButtonFind.Enabled := (FindText <> '') and (rdoFindEnabled in Options);

  if rdovFindNext in VisibleOptions then
    FButtonFindNext.Enabled := (FindText <> '') and (rdoFindNextEnabled in Options);

  if rdovReplace in VisibleOptions then
    FButtonReplace.Enabled := (FindText <> '') and (rdoReplaceEnabled in Options);

  if rdovReplaceAll in VisibleOptions then
    FButtonReplaceAll.Enabled := (FindText <> '') and (rdoReplaceAllEnabled in Options);
end;

function TTMSFNCCustomReplaceDialog.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

procedure TTMSFNCCustomReplaceDialog.MemoFindChange(Sender: TObject);
var
  s: string;
  i: Integer;
begin
  s := '';
  for i := 0 to FMemoFind.Lines.Count - 1 do
  begin
    if i > 0 then
      s := s + #13#10 + FMemoFind.Lines[i]
    else
      s := FMemoFind.Lines[i];
  end;

  DoReplaceEditChangeEvent(FindText, s);
  FindText := s;
  EnableButtons;
end;

procedure TTMSFNCCustomReplaceDialog.MemoReplaceChange(Sender: TObject);
var
  s: string;
  i: Integer;
begin
  s := '';
  for i := 0 to FMemoReplace.Lines.Count - 1 do
  begin
    if i > 0 then
      s := s + #13#10 + FMemoReplace.Lines[i]
    else
      s := FMemoReplace.Lines[i];
  end;

  DoReplaceEditChangeEvent(ReplaceText, s);
  ReplaceText := s;
  EnableButtons;
end;

procedure TTMSFNCCustomReplaceDialog.RadioDirClick(Sender: TObject);
begin
  if Assigned(FRadioDown) then
  begin
    {$IFDEF FMXLIB}
    if FRadioDown.IsChecked then
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    if FRadioDown.Checked then
    {$ENDIF}
      Options := Options + [rdoDown]
    else
      Options := Options - [rdoDown];
  end;
end;

procedure TTMSFNCCustomReplaceDialog.RadioRangeClick(Sender: TObject);
begin
  if Assigned(FRadioCurrentFile) and (rdovCurrentFile in VisibleOptions) then
  begin
    {$IFDEF FMXLIB}
    if FRadioCurrentFile.IsChecked then
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    if FRadioCurrentFile.Checked then
    {$ENDIF}
      Options := Options + [rdoCurrentFile]
    else
      Options := Options - [rdoCurrentFile];
  end;

  if Assigned(FRadioSelection) and (rdovSelection in VisibleOptions) then
  begin
    {$IFDEF FMXLIB}
    if FRadioSelection.IsChecked then
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    if FRadioSelection.Checked then
    {$ENDIF}
      Options := Options + [rdoSelection]
    else
      Options := Options - [rdoSelection];
  end;

  if Assigned(FRadioAllOpen) and (rdovAllOpenFiles in VisibleOptions) then
  begin
    {$IFDEF FMXLIB}
    if FRadioAllOpen.IsChecked then
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    if FRadioAllOpen.Checked then
    {$ENDIF}
      Options := Options + [rdoAllOpenFiles]
    else
      Options := Options - [rdoAllOpenFiles];
  end;
end;

procedure TTMSFNCCustomReplaceDialog.SetUILanguage(
  const Value: TTMSFNCReplaceDialogUILanguage);
begin
  FUILanguage.Assign(Value);
end;

procedure TTMSFNCCustomReplaceDialog.UILanguageChanged(Sender: TObject);
begin
  {$IFDEF WEBLIB}
  Caption := UILanguage.Caption;
  {$ENDIF}
end;

procedure TTMSFNCCustomReplaceDialog.UpdateMoreButton(const AValue: string);
begin
  if Assigned(FButtonMore) then
  begin
    {$IFDEF FMXLIB}
    FButtonMore.Text := AValue;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FButtonMore.Caption := AValue;
    {$ENDIF}
  end;
end;

{ TTMSFNCReplaceDialogUILanguage }

procedure TTMSFNCReplaceDialogUILanguage.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCReplaceDialogUILanguage then
  begin
    FCaseSensitive := (Source as TTMSFNCReplaceDialogUILanguage).CaseSensitive;
    FClose := (Source as TTMSFNCReplaceDialogUILanguage).Close;
    FDirection := (Source as TTMSFNCReplaceDialogUILanguage).Direction;
    FDown := (Source as TTMSFNCReplaceDialogUILanguage).Down;
    FExpression := (Source as TTMSFNCReplaceDialogUILanguage).Expression;
    FReplace := (Source as TTMSFNCReplaceDialogUILanguage).Replace;
    FCaption := (Source as TTMSFNCReplaceDialogUILanguage).Caption;
    FReplaceWith := (Source as TTMSFNCReplaceDialogUILanguage).ReplaceWith;
    FLess := (Source as TTMSFNCReplaceDialogUILanguage).Less;
    FMore := (Source as TTMSFNCReplaceDialogUILanguage).More;
    FSelection := (Source as TTMSFNCReplaceDialogUILanguage).Selection;
    FUp := (Source as TTMSFNCReplaceDialogUILanguage).Up;
    FWholeWordOnly := (Source as TTMSFNCReplaceDialogUILanguage).WholeWordOnly;
    FWrapAtEndOfFile := (Source as TTMSFNCReplaceDialogUILanguage).WrapAtEndOfFile;
    FAllOpenFiles := (Source as TTMSFNCReplaceDialogUILanguage).AllOpenFIles;
    FCurrentFile := (Source as TTMSFNCReplaceDialogUILanguage).CurrentFile;
    FFind := (Source as TTMSFNCReplaceDialogUILanguage).Find;
    FFindWhat := (Source as TTMSFNCReplaceDialogUILanguage).FindWhat;
    FReplaceAll := (Source as TTMSFNCReplaceDialogUILanguage).ReplaceAll;
    FReplaceAllRange := (Source as TTMSFNCReplaceDialogUILanguage).ReplaceAllRange;
  end
  else
    inherited;
end;

procedure TTMSFNCReplaceDialogUILanguage.Changed;
begin
  if Assigned(OnChanged) then
    OnChanged(Self);
end;

constructor TTMSFNCReplaceDialogUILanguage.Create;
begin
  FAllOpenFiles := 'All open files';
  FCaseSensitive := 'Case sensitive';
  FClose := 'Close';
  FDirection := 'Direction';
  FDown := 'Down';
  FExpression := 'Expression';
  FReplace := 'Replace';
  FCaption := 'Replace';
  FReplaceWith := 'Replace with:';
  FLess := 'Less';
  FMore := 'More';
  FSelection := 'Selection';
  FUp := 'Up';
  FWholeWordOnly := 'Whole word only';
  FWrapAtEndOfFile := 'Wrap at end of file';
  FFind := 'Find';
  FFindNext := 'Find next';
  FFindWhat := 'Find what:';
  FReplaceAll := 'Replace all';
  FReplaceAllRange := 'Replace all range';
  FCurrentFile := 'Current file';
end;

function TTMSFNCReplaceDialogUILanguage.IsAllOpenFilesStored: Boolean;
begin
  Result := FAllOpenFiles <> 'All open files';
end;

function TTMSFNCReplaceDialogUILanguage.IsCaptionStored: Boolean;
begin
  Result := FCaption <> 'Replace';
end;

function TTMSFNCReplaceDialogUILanguage.IsCaseSensitiveStored: Boolean;
begin
  Result := FCaseSensitive <> 'Case sensitive';
end;

function TTMSFNCReplaceDialogUILanguage.IsCloseStored: Boolean;
begin
  Result := FClose <> 'Close';
end;

function TTMSFNCReplaceDialogUILanguage.IsCurrentFileStored: Boolean;
begin
  Result := FCurrentFile <> 'Current file';
end;

function TTMSFNCReplaceDialogUILanguage.IsDirectionStored: Boolean;
begin
  Result := FDirection <> 'Direction';
end;

function TTMSFNCReplaceDialogUILanguage.IsDownStored: Boolean;
begin
  Result := FDown <> 'Down';
end;

function TTMSFNCReplaceDialogUILanguage.IsExpressionStored: Boolean;
begin
  Result := FExpression <> 'Expression';
end;

function TTMSFNCReplaceDialogUILanguage.IsFindNextStored: Boolean;
begin
  Result := FFindNext <> 'Find next';
end;

function TTMSFNCReplaceDialogUILanguage.IsFindStored: Boolean;
begin
  Result := FFind <> 'Find';
end;

function TTMSFNCReplaceDialogUILanguage.IsFindWhatStored: Boolean;
begin
  Result := FFindWhat <> 'Find what:';
end;

function TTMSFNCReplaceDialogUILanguage.IsReplaceAllRangeStored: Boolean;
begin
  Result := FReplaceAllRange <> 'Replace all range';
end;

function TTMSFNCReplaceDialogUILanguage.IsReplaceAllStored: Boolean;
begin
  Result := FReplaceAll <> 'Replace all';
end;

function TTMSFNCReplaceDialogUILanguage.IsReplaceStored: Boolean;
begin
  Result := FReplace <> 'Replace';
end;

function TTMSFNCReplaceDialogUILanguage.IsReplaceWithStored: Boolean;
begin
  Result := FReplaceWith <> 'Replace with:';
end;

function TTMSFNCReplaceDialogUILanguage.IsLessStored: Boolean;
begin
  Result := FLess <> 'Less';
end;

function TTMSFNCReplaceDialogUILanguage.IsMoreStored: Boolean;
begin
  Result := FMore <> 'More';
end;

function TTMSFNCReplaceDialogUILanguage.IsSelectionStored: Boolean;
begin
  Result := FSelection <> 'Selection';
end;

function TTMSFNCReplaceDialogUILanguage.IsUpStored: Boolean;
begin
  Result := FUp <> 'Up';
end;

function TTMSFNCReplaceDialogUILanguage.IsWholeWordOnlyStored: Boolean;
begin
  Result := FWholeWordOnly <> 'Whole word only';
end;

function TTMSFNCReplaceDialogUILanguage.IsWrapAtEndOfFileStored: Boolean;
begin
  Result := FWrapAtEndOfFile <> 'Wrap at end of file';
end;

procedure TTMSFNCReplaceDialogUILanguage.SetCaption(const Value: string);
begin
  if FCaption <> Value then
  begin
    FCaption := Value;
    Changed;
  end;
end;

end.
